import { useAuth } from "@components/context/AuthContext";
import { useEffect } from "react";

export function Logout() {
    const { handleLogout } = useAuth();
    useEffect(() => {
        // Logic for logging out the user
        async function logoutUser() {
            try {
                await handleLogout();
            } catch (error) {
                console.error('Logout Error:', error);
            }
        };

        logoutUser();
    }, [handleLogout]);

    return <></>; // No UI to render
}
